import React from "react"
import { AnimatePresence } from "framer-motion"
import { TQR_CODE_CONFIG } from "./utils/config"
import useTQRCodeData from "./hooks/useTQRCodeData"
import useTQRCodeVisuals from "./hooks/useTQRCodeVisuals"
import TQRCodeLoading from "./TQRCodeLoading"
import TQRCodeCheckedIn from "./TQRCodeCheckedIn"
import TQRCode from "./TQRCode"

type TemporalQRCodeComponentProps = {
  guestId: string
  qrCodeUrl: string
  eventPrimaryColor: string
  size?: number
  checkedIn?: boolean
}

const TemporalQRCodeComponent = ({
  guestId,
  qrCodeUrl,
  eventPrimaryColor,
  size = TQR_CODE_CONFIG.SIZE,
  checkedIn,
}: TemporalQRCodeComponentProps) => {
  const { isLoading, isCheckedIn, currentTQRCodeValue } = useTQRCodeData({
    qrCodeUrl,
    guestId,
    initialCheckedIn: checkedIn,
  })

  const { gradientColors, primaryColor } = useTQRCodeVisuals(
    eventPrimaryColor,
    isCheckedIn,
  )

  return (
    <AnimatePresence mode="wait" initial={false}>
      {isLoading ? (
        <TQRCodeLoading primaryColor={primaryColor} size={size} />
      ) : isCheckedIn ? (
        <TQRCodeCheckedIn size={size} />
      ) : (
        <TQRCode
          data={currentTQRCodeValue}
          size={size}
          gradientColors={gradientColors}
        />
      )}
    </AnimatePresence>
  )
}

export default TemporalQRCodeComponent
